import styled from 'foundations-theming-specialty/utils';
export const StyledSettingsIconWrapper = styled.button.withConfig({
  displayName: "StyledSettingsIconWrapper",
  componentId: "sc-1kp5wn5-0"
})(["display:", ";align-items:center;position:absolute;left:", ";top:", ";z-index:3;pointer-events:auto;cursor:pointer;user-select:none;background:transparent;border:none;padding:0;margin:0;&:focus-visible{outline:2px solid ", ";border-radius:", ";}"], ({
  isOpen
}) => isOpen ? 'flex' : 'none', ({
  theme
}) => `calc(${theme.space['600']} + calc(var(--search-layout-width, 500px) - 30px) + ${theme.space['400']})`, ({
  theme
}) => `calc(${theme.space['400']} + ${theme.space['400']})`, ({
  theme
}) => theme.color['border-info-default'], ({
  theme
}) => theme.borderRadius['100']);